import React from 'react';
import ImageSettingsPanel from './ImageSettingsPanel';
import ImageTuningPanel from './ImageTuningPanel';
import './ImageSettings.scss';
import { CaptureProfileType, ImageSettingsRowInfo } from '../types';
import RobotSettings from './RobotSettings';
import { Robot } from 'business/models/Models';

interface ImageSettingsContainerProps {
  setEnableHeaderButtons: (flag: boolean) => void;
  cpData: CaptureProfileType;
  setCpData: React.Dispatch<React.SetStateAction<CaptureProfileType>>;
  enableAll: boolean;
  setEnableAll: React.Dispatch<React.SetStateAction<boolean>>;
  importFlAll: boolean;
  setImportFlAll: React.Dispatch<React.SetStateAction<boolean>>;
  imageSettingErrors: ImageSettingsRowInfo;
  selectedRows: Array<number>;
  setSelectedRows: React.Dispatch<React.SetStateAction<Array<number>>>;
  selectedCps: Array<number>;
  setSelectedCps: React.Dispatch<React.SetStateAction<Array<number>>>;
  deletedImagingSettings: Array<number>;
  setDeletedImagingSettings: React.Dispatch<React.SetStateAction<Array<number>>>;
  robots: Robot[];
  tuningFieldError?: string;
  setTuningFieldError?: React.Dispatch<React.SetStateAction<string>>;
}

const ImageSettingsContainer = (props: ImageSettingsContainerProps) => {
  const {
    setEnableHeaderButtons,
    cpData,
    setCpData,
    enableAll,
    setEnableAll,
    importFlAll,
    setImportFlAll,
    imageSettingErrors,
    selectedRows,
    setSelectedRows,
    selectedCps,
    setSelectedCps,
    deletedImagingSettings,
    setDeletedImagingSettings,
    robots,
    tuningFieldError,
    setTuningFieldError,
  } = props;
  return (
    <div id="imagesettingscontainer" className="h-[91vh]">
      <div id="imagesettingscontainer-wrapper" className="flex flex-row h-full">
        <div
          id="imagesettingscontainer-imagesettingpanel"
          className="flex flex-row w-[25%] h-full border overflow-auto"
        >
          <ImageSettingsPanel
            setEnableHeaderButtons={setEnableHeaderButtons}
            cpData={cpData}
            setCpData={setCpData}
            enableAll={enableAll}
            setEnableAll={setEnableAll}
            importFlAll={importFlAll}
            setImportFlAll={setImportFlAll}
            imageSettingErrors={imageSettingErrors}
            selectedCps={selectedCps}
            setSelectedCps={setSelectedCps}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            deletedImagingSettings={deletedImagingSettings}
            setDeletedImagingSettings={setDeletedImagingSettings}
          />
        </div>
        <div
          id="imagesettingscontainer-robotsettings"
          className="w-[45%] border h-[95%] overflow-auto"
        >
          <RobotSettings
            cpData={cpData}
            setCpData={setCpData}
            setIsDirty={setEnableHeaderButtons}
            robots={robots}
          />
        </div>
        <div id="imagesettingscontainer-imagetuningpanel" className="w-[30%] border">
          <ImageTuningPanel
            setEnableHeaderButtons={setEnableHeaderButtons}
            selectedCps={selectedCps}
            selectedRows={selectedRows}
            cpData={cpData}
            setCpData={setCpData}
            tuningFieldError={tuningFieldError}
            setTuningFieldError={setTuningFieldError}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageSettingsContainer;
